// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

/** Labels only — Sentry still runs. Real prod hosts (e.g. `*.sh0p.in`, custom domains) stay `production`. */
const getEnvironment = () => {
  if (typeof window === "undefined") return "production";

  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "development";
  }

  // Staging / preview storefronts
  if (hostname.endsWith(".dev.sh0p.in") || hostname === "dev.sh0p.in") {
    return "development";
  }

  return "production";
};

const shouldDropClientEvent = (event) => {
  const error = event.exception?.values?.[0];
  if (!error) return false;

  const value = error.value || "";
  const frames = error.stacktrace?.frames || [];
  const inNewRelic = frames.some((f) => {
    const file = f.filename || f.abs_path || "";
    return /newrelic|nr-loader|bel-serializer|browser-agent/i.test(file);
  });

  if (value.includes("ResizeObserver loop completed with undelivered notifications")) {
    return true;
  }

  // NR soft-nav / BEL serializer bug: `c.replace is not a function`
  if (inNewRelic && /replace is not a function/i.test(value)) {
    return true;
  }

  return false;
};

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 0,
  debug: false,
  environment: getEnvironment(),

  beforeSend(event) {
    if (shouldDropClientEvent(event)) return null;
    return event;
  },
});
